import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { Booking, RhBooking } from '../app/models/booking.model';

@Injectable({
  providedIn: 'root'
})
export class BookingService {
  constructor(private http: HttpClient) {}

  getBookingById(bookingId: string): Observable<Booking> {
    return this.http
      .get<{ data: Booking }>(`${environment.operational_url}CorprateOrder/booking/${bookingId}`)
      .pipe(map((res) => res.data));
  }

  getRideBookingById(id: string): Observable<RhBooking> {
    return this.http
      .get<{ data: RhBooking }>(`${environment.operational_url}AdminOrder/ride-hailing/getRideBooking/${id}`)
      .pipe(map(res => res.data));
  }

  getBookingTracking(id: string): Observable<any> {
    return this.http
      .get<{ data: any }>(`${environment.operational_url}CorprateOrder/getBookingTracking/${id}`)
      .pipe(map((res) => res.data));
  }
}
